import { Link } from "react-router-dom";
import { ShieldCheck, Languages } from "lucide-react";
import { useT } from "@/lib/i18n";

const LANGS = [
  { code: "en", label: "English" },
  { code: "mi", label: "Māori" },
  { code: "ar", label: "العربية" },
];

export default function Header() {
  const { t, lang, setLang } = useT();

  return (
    <header className="border-b border-[var(--iddl-rule)]" data-testid="iddl-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3" data-testid="iddl-home-link">
          <div className="w-8 h-8 bg-[var(--iddl-ink)] text-white grid place-items-center">
            <ShieldCheck size={16} strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <div className="font-display text-base font-bold tracking-tight">
              {t("header.brand_name")}
            </div>
            <div className="label-mono">{t("header.brand_sub")}</div>
          </div>
        </Link>
        <label
          className="inline-flex items-center gap-2 border border-[var(--iddl-rule)] h-9 px-3 cursor-pointer hover:bg-[var(--iddl-surface)] transition-colors"
          data-testid="lang-switcher"
          aria-label="Switch language"
        >
          <Languages size={14} />
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            data-testid="select-lang"
            className="bg-transparent label-mono outline-none border-0 cursor-pointer pr-1"
            style={{ letterSpacing: "0.1em" }}
          >
            {LANGS.map((l) => (
              <option key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
                {l.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </header>
  );
}
